import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IActivityBank, IActivityBankAddDto, IActivityBankSearchRequest, IActivityBankSearchResponseDto, IChildActivityBankDto } from '@core/interfaces/iactivity-bank';
import { DataService } from './data.service';
import { IReportSearch } from '@views/user/reports';
import { IClassPlanningActivityResult } from '@core/interfaces/iclass-planning';

@Injectable({
  providedIn: 'root'
})
export class ActivityBankService {

  constructor(private dataService: DataService) { }

  search(payload: IActivityBankSearchRequest): Observable<IActivityBankSearchResponseDto[]> {
    return this.dataService.post(`activityBank/search`, payload);
  }

  updateDescription(payload: IActivityBank): Observable<boolean> {
    return this.dataService.put(`activityBank`, payload);
  }

  updateChildActivitySelections(payload: IChildActivityBankDto[], message?: string): Observable<boolean> {
    return this.dataService.put('activityBank/child-activity', payload, message);
  }

  getNextByMeasureEnrollmentClass(payload: IReportSearch): Observable<IClassPlanningActivityResult> {
    return this.dataService.post('activityBank/child-activity/next-level-activities', payload);
  }

  deleteDescription(id: number): Observable<boolean> {
    return this.dataService.delete(`activityBank?id=${id}`);
  }

  addDescription(payload: IActivityBankAddDto): Observable<boolean> {
    return this.dataService.post(`activityBank/add`, payload);
  }
}